import React from "react";
import { createRoot } from "react-dom/client";
import "./utils/dateLocale";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

document.documentElement?.setAttribute("lang", "en-GB");

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);

// Register service worker for PWA support
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker?.register("/sw.js")?.then((registration) => {
        console.log("SW registered:", registration?.scope);
      })?.catch((error) => {
        // SW registration failed — app still works normally
        console.log("SW registration skipped:", error?.message);
      });
  });
}